module.exports = __webpack_public_path__ + "img/pd.b370e00a.jpeg";